import script from "./HmsChartV2Old.vue?vue&type=script&setup=true&lang=js"
export * from "./HmsChartV2Old.vue?vue&type=script&setup=true&lang=js"

import "./HmsChartV2Old.vue?vue&type=style&index=0&id=925b5b3a&scoped=true&lang=css"

import exportComponent from "C:\\Development\\branches\\Code\\Htm\\HTM_Website\\Publictest052024\\vue\\hms\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-925b5b3a"]])

export default __exports__